const m = window.require("@ember/runloop");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;